import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
  categoryList: [],
  categoryDetail: null,
  bedList: [],
  roomMasterTypes: [],
  mattressList: [],
  facilitySubFacilityList: [],
  subFacilityList: [],
  roomCategoryTypes: [],
  roomTypeDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  roomTypeSearchFilters: {
    searchText: "",
    typeActivityStatus: "",
  },
  cleaningDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  cleaningSearchFilters: {
    searchText: "",
    typeActivityStatus: "",
  },
  addOnDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  addOnSearchFilters: {
    searchText: "",
  },
  taxDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  taxSearchFilters: {
    searchText: "",
  },
  occCriDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  minStayDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  speCriDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  bookingEngineOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  couponCodeListOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  templateList: {
    agreement_acceptance: "",
    general_release: "",
    credit_card_authorization: "",
    id:0
  },
  bookingRestrictionDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  bookingRestrictionSearchFilters: {
    searchText: "",
  },
  attrationDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  attrationSearchFilters: {
    searchText: "",
  },
  miscellaneousChargesDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  miscellaneousChargesSearchFilters: {
    searchText: "",
  },
  operatingExpensesDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  operatingExpensesSearchFilters: {
    searchText: 0,
  },
  packagesDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  packagesSearchFilters: {
    searchText: "",
  },
  packagesList: [],
  loyaltyProgramDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  loyaltyProgramSearchFilters: {
    searchText: "",
  },
  loyaltyProgramList: [],
  bonusRulesDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  bonusRulesSearchFilters: {
    searchText: "",
  },
  bonusRulesList: [],

  propertyMaintenanaceOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  propertyMaintenanaceSearchFilters: {
    searchText: ""
  },
  recurringChargeDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  recurringChargeSearchFilters: {
    searchText: ""
  },
  smsCommunicationTemplates: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  emailCommunicationTemplates: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  communicationTemplatesSearchFilters: {
    searchText: ""
  },
  communicationTemplatesUserType: 1,
  loyaltyProgramUserType: 1,
};
const roomCategorySlice = createSlice({
  name: "hotel",
  initialState: initialState,
  reducers: {
    roomCategoryListSuccess: (state, action) => {
      state.categoryList = action.payload;
    },
    roomCategoryListFailed: (state, action) => {
      state.categoryList = [];
    },
    roomTypeDatagridOptionsSuccess: (state, action) => {
      state.roomTypeDatagridOptions =  {...state.roomTypeDatagridOptions, [action.payload.key]: action.payload.value}
    },
    roomTypeSearchFiltersSuccess: (state, action) => {
      state.roomTypeSearchFilters = {...state.roomTypeSearchFilters, [action.payload.key]: action.payload.value};
    },
    cleaningDatagridOptionsSuccess: (state, action) => {
      state.cleaningDatagridOptions =  {...state.cleaningDatagridOptions, [action.payload.key]: action.payload.value}
    },
    cleaningSearchFiltersSuccess: (state, action) => {
      state.cleaningSearchFilters = {...state.cleaningSearchFilters, [action.payload.key]: action.payload.value};
    },
    addOnDatagridOptionsSuccess: (state, action) => {
      state.addOnDatagridOptions =  {...state.addOnDatagridOptions, [action.payload.key]: action.payload.value}
    },
    addOnSearchFiltersSuccess: (state, action) => {
      state.addOnSearchFilters = {...state.addOnSearchFilters, [action.payload.key]: action.payload.value};
    },
    taxDataGridOptionsSuccess: (state, action) => {
      state.taxDataGridOptions =  {...state.taxDataGridOptions, [action.payload.key]: action.payload.value}
    },
    taxSearchFiltersSuccess: (state, action) => {
      state.taxSearchFilters = {...state.taxSearchFilters, [action.payload.key]: action.payload.value};
    },
    bookingRestrictionDataGridOptionsSuccess: (state, action) => {
      state.bookingRestrictionDataGridOptions =  {...state.bookingRestrictionDataGridOptions, [action.payload.key]: action.payload.value}
    },
    bookingRestrictionSearchFiltersSuccess: (state, action) => {
      state.bookingRestrictionSearchFilters = {...state.bookingRestrictionSearchFilters, [action.payload.key]: action.payload.value};
    },
    attrationDatagridOptionsSuccess: (state, action) => {
      state.attrationDatagridOptions =  {...state.attrationDatagridOptions, [action.payload.key]: action.payload.value}
    },
    attrationSearchFiltersSuccess: (state, action) => {
      state.attrationSearchFilters = {...state.attrationSearchFilters, [action.payload.key]: action.payload.value};
    },
    miscellaneousChargesDatagridOptionsSuccess: (state, action) => {
      state.miscellaneousChargesDatagridOptions =  {...state.miscellaneousChargesDatagridOptions, [action.payload.key]: action.payload.value}
    },
    miscellaneousChargesSearchFiltersSuccess: (state, action) => {
      state.miscellaneousChargesSearchFilters = {...state.miscellaneousChargesSearchFilters, [action.payload.key]: action.payload.value};
    },
    operatingExpensesDatagridOptionsSuccess: (state, action) => {
      state.operatingExpensesDatagridOptions =  {...state.operatingExpensesDatagridOptions, [action.payload.key]: action.payload.value}
    },
    operatingExpensesSearchFiltersSuccess: (state, action) => {
      state.operatingExpensesSearchFilters = {...state.operatingExpensesSearchFilters, [action.payload.key]: action.payload.value};
    },
    packagesOptionsSuccess: (state, action) => {
      state.packagesDatagridOptions =  {...state.packagesDatagridOptions, [action.payload.key]: action.payload.value}
    },
    packagesSearchFiltersSuccess: (state, action) => {
      state.packagesSearchFilters = {...state.packagesSearchFilters, [action.payload.key]: action.payload.value};
    },
    packagesListSuccess: (state, action) => {
      state.packagesList = action.payload;
    },
    loyaltyProgramOptionsSuccess: (state, action) => {
      state.loyaltyProgramDatagridOptions =  {...state.loyaltyProgramDatagridOptions, [action.payload.key]: action.payload.value}
    },
    loyaltyProgramSearchFiltersSuccess: (state, action) => {
      state.loyaltyProgramSearchFilters = {...state.loyaltyProgramSearchFilters, [action.payload.key]: action.payload.value};
    },
    loyaltyProgramListSuccess: (state, action) => {
      state.loyaltyProgramList = action.payload;
    },
    bonusRulesOptionsSuccess: (state, action) => {
      state.bonusRulesDatagridOptions =  {...state.bonusRulesDatagridOptions, [action.payload.key]: action.payload.value}
    },
    bonusRulesSearchFiltersSuccess: (state, action) => {
      state.bonusRulesSearchFilters = {...state.bonusRulesSearchFilters, [action.payload.key]: action.payload.value};
    },
    bonusRulesListSuccess: (state, action) => {
      state.bonusRulesList = action.payload;
    },
    propertyMaintenanaceOptionsSuccess: (state, action) => {
      state.propertyMaintenanaceOptions =  {...state.propertyMaintenanaceOptions, [action.payload.key]: action.payload.value}
    },
    propertyMaintenanaceSearchFiltersSuccess: (state, action) => {
      state.propertyMaintenanaceSearchFilters = {...state.propertyMaintenanaceSearchFilters, [action.payload.key]: action.payload.value};
    },
    recurringChargeDatagridOptionsSuccess: (state, action) => {
      state.recurringChargeDatagridOptions =  {...state.recurringChargeDatagridOptions, [action.payload.key]: action.payload.value}
    },
    recurringChargeSearchFiltersSuccess: (state, action) => {
      state.recurringChargeSearchFilters = {...state.recurringChargeSearchFilters, [action.payload.key]: action.payload.value};
    },
    smsCommunicationTemplatesSuccess: (state, action) => {
      state.smsCommunicationTemplates =  {...state.smsCommunicationTemplates, [action.payload.key]: action.payload.value}
    },
    emailCommunicationTemplatesSuccess: (state, action) => {
      state.emailCommunicationTemplates =  {...state.emailCommunicationTemplates, [action.payload.key]: action.payload.value}
    },
    communicationTemplatesSearchFiltersSuccess: (state, action) => {
      state.communicationTemplatesSearchFilters = {...state.communicationTemplatesSearchFilters, [action.payload.key]: action.payload.value};
    },
    occCriDatagridOptionsSuccess: (state, action) => {
      state.occCriDatagridOptions =  {...state.occCriDatagridOptions, [action.payload.key]: action.payload.value}
    },
    minStayDatagridOptionsSuccess: (state, action) => {
      state.minStayDatagridOptions =  {...state.minStayDatagridOptions, [action.payload.key]: action.payload.value}
    },
    speCriDatagridOptionsSuccess: (state, action) => {
      state.speCriDatagridOptions =  {...state.speCriDatagridOptions, [action.payload.key]: action.payload.value}
    },
    bookingEngineOptionsSuccess: (state, action) => {
      state.bookingEngineOptions =  {...state.bookingEngineOptions, [action.payload.key]: action.payload.value}
    },
    couponCodeListOptionsSuccess: (state, action) => {
      state.couponCodeListOptions =  {...state.couponCodeListOptions, [action.payload.key]: action.payload.value}
    },
    communicationTemplatesUserTypeSuccess: (state, action) => {
      state.communicationTemplatesUserType = action.payload;
    },
    loyaltyProgramUserTypeSuccess: (state, action) => {
      state.loyaltyProgramUserType = action.payload;
    },
    templateListSuccess: (state, action) => {
      state.templateList = action.payload;
    },
    roomCategoryDetailSuccess: (state, action) => {
      state.categoryDetail = action.payload;
    },
    roomCategoryDetailFailed: (state, action) => {
      state.categoryDetail = null;
    },
    bedListSuccess: (state, action) => {
      state.bedList = action.payload;
    },
    bedListFailed: (state, action) => {
      state.bedList = null;
    },
    roomMasterTypesSuccess: (state, action) => {
      state.roomMasterTypes = action.payload;
    },
    roomMasterTypesFailed: (state, action) => {
      state.roomMasterTypes = null;
    },
    mattressListSuccess: (state, action) => {
      state.mattressList = action.payload;
    },
    mattressListFailed: (state, action) => {
      state.mattressList = null;
    },
    facilitySubFacilityListSuccess: (state, action) => {
      state.facilitySubFacilityList = action.payload;
    },
    facilitySubFacilityListFailed: (state, action) => {
      state.facilitySubFacilityList = [];
    },
    subFacilityListSuccess: (state, action) => {
      state.subFacilityList = action.payload;
    },
    subFacilityListFailed: (state, action) => {
      state.facilitySubFacilityList = [];
    },
    roomCategoryTypesSuccess: (state, action) => {
      state.roomCategoryTypes = action.payload;
    },
    roomCategoryTypesFailed: (state, action) => {
      state.roomCategoryTypes = [];
    },
  },
});

export const {
  roomCategoryListSuccess,
  roomCategoryListFailed,
  roomTypeDatagridOptionsSuccess,
  roomTypeSearchFiltersSuccess,
  roomCategoryDetailSuccess,
  roomCategoryDetailFailed,
  bedListSuccess,
  bedListFailed,
  roomMasterTypesSuccess,
  roomMasterTypesFailed,
  mattressListSuccess,
  mattressListFailed,
  facilitySubFacilityListSuccess,
  facilitySubFacilityListFailed,
  roomCategoryTypesSuccess,
  roomCategoryTypesFailed,
  subFacilityListSuccess,
  subFacilityListFailed,
  cleaningDatagridOptionsSuccess,
  cleaningSearchFiltersSuccess,
  addOnDatagridOptionsSuccess,
  addOnSearchFiltersSuccess,
  taxDataGridOptionsSuccess,
  taxSearchFiltersSuccess,
  occCriDatagridOptionsSuccess,
  minStayDatagridOptionsSuccess,
  speCriDatagridOptionsSuccess,
  bookingEngineOptionsSuccess,
  couponCodeListOptionsSuccess,
  templateListSuccess,
  bookingRestrictionDataGridOptionsSuccess,
  bookingRestrictionSearchFiltersSuccess,
  attrationDatagridOptionsSuccess,
  attrationSearchFiltersSuccess,
  miscellaneousChargesDatagridOptionsSuccess,
  miscellaneousChargesSearchFiltersSuccess,
  operatingExpensesDatagridOptionsSuccess,
  operatingExpensesSearchFiltersSuccess,
  packagesOptionsSuccess,
  packagesSearchFiltersSuccess,
  packagesListSuccess,
  loyaltyProgramOptionsSuccess,
  loyaltyProgramSearchFiltersSuccess,
  loyaltyProgramListSuccess,
  bonusRulesOptionsSuccess,
bonusRulesSearchFiltersSuccess,
bonusRulesListSuccess,
  propertyMaintenanaceOptionsSuccess,
  propertyMaintenanaceSearchFiltersSuccess,
  recurringChargeDatagridOptionsSuccess,
  recurringChargeSearchFiltersSuccess,
  smsCommunicationTemplatesSuccess,
  emailCommunicationTemplatesSuccess,
  communicationTemplatesSearchFiltersSuccess,
  communicationTemplatesUserTypeSuccess,
  loyaltyProgramUserTypeSuccess,
} = roomCategorySlice.actions;
export default roomCategorySlice.reducer;
